import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Typography,
  Button,
  InputNumber,
  Popconfirm,
  Space,
  Select,
  Modal,
  Divider,
  Alert,
  AutoComplete,
} from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import useMessage from "antd/es/message/useMessage";
import Title from "antd/es/skeleton/Title";
import { QuotationService } from "../../../../Services/Manage/QuotationService";
import { LetterService } from "../../../../Services/Manage/LetterService";
import { ENDPOINT } from "../../../../Services/ENDPOINT";
import dayjs from "dayjs";
import { BankService } from "../../../../Services/Manage/BankService";
import { UserService } from "../../../../Services/Manage/UserService";
import { ExpenseServices } from "../../../../Services/Manage/ExpenseServices";
import CreatePayment from "../../../modals/CreatePayment";
import html2pdf from "html2pdf.js";
import { EnquiryService } from "../../../../Services/Manage/EnquiryService";
import QuotationInvoiceTemplate from "../../template/QuotationInvoiceTemplate";

const EditQuotationData = ({
  quteData,
  Eqslected,
  data,
  initialData,
  selectedDate,
  eqData,
}) => {
  const { Text, Title } = Typography;
  const [form] = Form.useForm();
  const [selectBank] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [count, setCount] = useState(3);
  const [grandTotal, setGrandTotal] = useState(0);
  const [message, msgContc] = useMessage();
  const [letterHead, setLetterHead] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedTC, setSelectedTC] = useState([]);
  const [selectedTCOption, setSelectedTCOption] = useState([]);
  const [dgSign, setDGsign] = useState(null);
  const [dgSignOption, setDGsignOption] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  const [bankAc, setBankAc] = useState(null);
  const [bankAcOption, setBankAcOption] = useState([]);

  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [quotationNo, setQuotationNo] = useState(null);

  const [options, setOptions] = useState([]);

  const getBase64Image = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // important for CORS
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = url;
    });

  const waitForImages = (container) => {
    const images = container.querySelectorAll("img");
    const promises = Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();
      return new Promise((resolve) => {
        img.onload = () => resolve();
        img.onerror = () => resolve(); // still resolve to avoid blocking PDF
      });
    });
    return Promise.all(promises);
  };

  const taxOptions = ["GST", "VAT", "Service Tax", "Excise", "Custom Duty"];
  const handleSearch = (value) => {
    setOptions(
      value
        ? taxOptions
          .filter((tax) => tax.toLowerCase().includes(value.toLowerCase()))
          .map((tax) => ({ value: tax }))
        : []
    );
  };
  const handlePreview = () => {
    if (selectedValue) {
      setIsModalOpen(true);
    }
  };


  console.log("IUGuguigeiuadgsuvgdigcerisuvdfkzx", bankAc);

  console.log(data, selectedDate);

  const getAllLetterhead = async () => {
    try {
      const request = await LetterService.getAllHead();
      setLetterHead(
        request.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getBankAcOption = async () => {
    try {
      const request = await BankService.getAllBank();
      setBankAcOption(
        request.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllTCData = async () => {
    try {
      const response = await LetterService.getAllTC();
      setSelectedTCOption(
        response.data.map((item, index) => ({
          label: item.tag,
          value: item.id,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getDigitalSign = async () => {
    try {
      const response = await QuotationService.getDigitalSign();
      setDGsignOption(
        response.data.map((item) => ({
          label: (
            <img
              src={`${ENDPOINT.base}/${item.image_path}`}
              alt={`Signature ${item.id}`}
              style={{ width: "100px", height: "auto", objectFit: "contain" }}
            />
          ),
          value: item.id,
          title: `Signature ${item.id}`,
          ...item,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllLetterhead();
    getAllTCData();
    getBankAcOption();
    getDigitalSign();
    form.setFieldsValue({
      quotationNo: quteData?.qu_no,
      gstNo: quteData?.cus_gst,
      tax_id: quteData?.tax_id,
      tax_type: quteData?.tax_type,
    });

    const formattedData = initialData.map((item, index) => ({
      ...item,
      key: item.id ?? index,
    }));

    setDataSource(formattedData);

    console.log(initialData);
  }, [data, form, initialData, quteData]);

  //bank ac
  useEffect(() => {
    if (bankAcOption.length > 0 && quteData?.bank_id) {
      const selected = bankAcOption.find(
        (opt) => opt.value === Number(quteData.bank_id)
      );
      if (selected) {
        selectBank.setFieldsValue({
          bank_ac: selected?.tag,
        });

        setBankAc(selected);
      }
    }
  }, [bankAcOption, quteData]);

  useEffect(() => {
    if (letterHead.length > 0 && quteData?.header_id) {
      const selected = letterHead.find(
        (opt) => opt.value === Number(quteData.header_id)
      );
      if (selected) {
        setSelectedOption(selected);
      }
    }
  }, [letterHead, quteData]);

  useEffect(() => {
    if (selectedTCOption.length > 0 && quteData?.tc_id) {
      const selected = selectedTCOption.find(
        (opt) => opt.value === Number(quteData.tc_id)
      );
      if (selected) {
        setSelectedValue(selected);
      }
    }
  }, [selectedTCOption, quteData]);

  useEffect(() => {
    if (dgSignOption.length > 0 && quteData?.sign_id) {
      const selected = dgSignOption.find(
        (opt) => opt.value === Number(quteData.sign_id)
      );
      if (selected) {
        setDGsign(selected);
      }
    }
  }, [dgSignOption, quteData]);

  const numberToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const g = ["", "Thousand", "Million", "Billion"];

    if (num === 0) return "Zero";

    let str = "";
    let grp = 0;

    while (num > 0) {
      let chunk = num % 1000;
      if (chunk) {
        let chunkStr = "";
        if (chunk > 99) {
          chunkStr += a[Math.floor(chunk / 100)] + " Hundred ";
          chunk %= 100;
        }
        if (chunk > 19) {
          chunkStr += b[Math.floor(chunk / 10)] + " ";
          chunk %= 10;
        }
        if (chunk > 0) chunkStr += a[chunk] + " ";
        str = chunkStr + g[grp] + " " + str;
      }
      num = Math.floor(num / 1000);
      grp++;
    }
    return str.trim();
  };

  useEffect(() => {
    calculateGrandTotal();
  }, [dataSource]);

  const handleDelete = async (record) => {
    console.log(record);
    try {
      const request = await QuotationService.deleteQuotation(record.id);
      const newData = dataSource.filter((item) => item.id !== record.id);
      setDataSource(newData);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (key, field, value) => {
    const newData = dataSource.map((item) => {
      if (item.key === key) {
        const updatedItem = { ...item, [field]: value };
        const basePrice = updatedItem.qty * updatedItem.unitprice;
        const taxPercent = updatedItem.tax || 0;
        const total = basePrice + (basePrice * taxPercent) / 100;

        // Round to nearest integer
        updatedItem.totalprice = Math.round(total);

        return updatedItem;
      }
      return item;
    });
    setDataSource(newData);
  };

  const calculateGrandTotal = () => {
    const total = dataSource.reduce((sum, item) => sum + item.totalprice, 0);
    setGrandTotal(total);
  };

  const columns = [
    {
      title: "SI No",
      dataIndex: "key",
      width: "7%",
      align: "center",
      key: "key",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => (
        <TextArea
          allowClear
          rows={2}
          value={text}
          onChange={(e) =>
            handleChange(record.key, "description", e.target.value)
          }
        />
      ),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: "12%",
      align: "center",
      key: "qty",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleChange(record.key, "qty", value)}
        />
      ),
    },
    {
      title: "Unit Price",
      dataIndex: "unitprice",
      align: "center",
      width: "12%",
      key: "unitprice",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleChange(record.key, "unitprice", value)}
        />
      ),
    },
    {
      title: "Tax (in %)",
      dataIndex: "tax",
      width: "12%",
      align: "center",
      key: "tax",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) => handleChange(record.key, "tax", value)}
        />
      ),
    },
    {
      title: "Total Price",
      dataIndex: "totalprice",
      align: "center",
      key: "totalprice",
      render: (text) => <Text>{text}</Text>,
      width: "10%",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <>
          <Button
            disabled={!Eqslected}
            icon={<PlusOutlined />}
            type="dashed"
            size="large"
            style={{ marginRight: 8 }}
            onClick={() => handleAdd(record.key)}
          />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record)}
          >
            <Button disabled={!Eqslected} icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </>
      ),
    },
  ];

  const handleNewAdd = () => {
    setDataSource([
      ...dataSource,
      {
        key: count,
        description: "",
        qty: 1,
        unitprice: 0,
        totalprice: 0,
      },
    ]);
    setCount(count + 1);
  };

  const handleAdd = (key) => {
    const newRow = {
      key: count,
      description: "",
      qty: 1,
      unitprice: 0,
      totalprice: 0,
    };
    const index = dataSource.findIndex((item) => item.key === key);

    let newData = [...dataSource];
    newData.splice(index + 1, 0, newRow);
    setDataSource(newData);
    setCount(count + 1);
  };

const handleSave = async () => {
  try {
    // REMOVE THESE - no validation required
    // if (!selectedValue) return message.warning("Please select Terms & Conditions");
    // if (!dgSign) return message.warning("Please select Digital Signature");
    // if (!bankAc) return message.warning("Please select Bank Account");

    if (!dataSource || dataSource.length <= 0) {
      return message.warning("Please Add contents");
    }

    const request = form.getFieldsValue();
    const user = await UserService.getOmeUser();

    const formattedData = dataSource.map((item) => ({
      id: item.id,
      description: item.description,
      qty: item.qty,
      tax: item.tax,
      totalprice: item.totalprice,
      unitprice: item.unitprice,
      qu_no: request.quotationNo,
    }));

    const data_insert = {
      qu_no: request.quotationNo,
      tax_id: request.tax_id,
      tax_type: request.tax_type,
      eq_no: eqData?.eq_id,
      date: selectedDate,
      cus_gst: request?.gstNo,

      // Make optional fields NULL if not selected
      tc_id: selectedValue?.id || null,
      sign_id: dgSign?.id || null,
      bank_id: bankAc?.id || null,

      added_by: user?.uid,
    };

    const send_both = {
      formattedData,
      quotation_insert: data_insert,
    };

    const requests = await QuotationService.updateQuotation(
      send_both,
      request.quotationNo
    );

    if (requests.status) message.success(requests.message);
    else message.error(requests.message);

  } catch (error) {
    console.error(error);
  }
};


const handlePrintInvoice = async (qu_no) => {
  try {
    const quotationRes = await QuotationService.getAllQuotationById(qu_no);
    const quotation = quotationRes?.data?.quotation;
    const quotationData = dataSource;

    const enquiryRes = await EnquiryService.getEnquiryDetailsById(quotation.eq_no);
    const enquiry = enquiryRes?.data;

    const headerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "header");
    const footerImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "footer");
    const watermarkImageObj = letterHead.find(lh => lh.tag.toLowerCase() === "watermark");

    const headerBase64 = headerImageObj ? await getBase64Image(`${ENDPOINT.base}/${headerImageObj.image_url}`) : "";
    const footerBase64 = footerImageObj ? await getBase64Image(`${ENDPOINT.base}/${footerImageObj.image_url}`) : "";
    const dgSignBase64 = dgSign ? await getBase64Image(`${ENDPOINT.base}/${dgSign.image_path}`) : "";
    const watermarkBase64 = watermarkImageObj ? await getBase64Image(`${ENDPOINT.base}/${watermarkImageObj.image_url}`) : "";

    const pdfDoc = QuotationInvoiceTemplate({
      headerBase64,
      footerBase64,
      dgSignBase64,
      watermarkBase64,
      quotation,
      enquiry,
      quotationData,
        invoice_date: quotation.date,
      grandTotal,
      numberToWords,
      bankAc,
      selectedValue,
        tax_type: form.getFieldValue("tax_type"), // <-- Add this
  tax_id: form.getFieldValue("tax_id"), 
      type: "QUOTATION",
         currency: enquiry.currency 
    });

    pdfDoc.save(`${quotation.qu_no || "Quotation"}.pdf`);
  } catch (error) {
    console.error(error);
    message.error("Failed to generate PDF!");
  }
};

  const handleAddPayment = async () => {
    try {
      const request = form.getFieldsValue();
      console.log("handleAddPayment", request.quotationNo);

      // save quotationNo and open modal
      setQuotationNo(request.quotationNo);
      setPaymentModalOpen(true);
    } catch (error) {
      console.error("Error in handleAddPayment:", error);
    }
  };

  const handleClear = async () => {
    setDataSource([]);
  };

  return (
    <>
      {msgContc}
      <Form form={form} layout="vertical" style={{ width: "100%" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              label="Quotation No"
              name="quotationNo"
              initialValue={data}
              style={{ width: "100%" }}
            >
              <Input disabled placeholder="Enter Quotation No" size="large" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item
              label="Tax type"
              name="tax_type"
              initialValue={data?.tax_type}
            >
              <AutoComplete
                allowClear
                style={{ width: "100%" }}
                options={options}
                onSearch={handleSearch}
                placeholder="Enter Tax type (e.g. GST, VAT)"
                size="large"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Tax ID" name="tax_id" initialValue={data?.tax_id}>
              <Input
                allowClear
                placeholder="Enter Tax ID (e.g. 09AAACH7409R1ZZ)"
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Card style={{ marginTop: "30px", borderBlockColor: "black" }}>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
              position: "relative",
              // height: "64px",
            }}
          >
            <Button
              disabled={!Eqslected}
              icon={<PlusOutlined />}
              size="large"
              type="primary"
              onClick={handleNewAdd}
            >
              Add Row
            </Button>
          </div>

          <Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            rowKey="id"
            summary={() => {
              let totalQty = 0;
              let totalprice = 0;

              dataSource.forEach(({ qty, totalprice: rowTotal }) => {
                totalQty += qty;
                totalprice += rowTotal;
              });

              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={2}>
                    <Text strong>Total</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2}>
                    <Text strong>{totalQty}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3}></Table.Summary.Cell>
                  <Table.Summary.Cell index={4}>
                    <Text strong>{totalprice}</Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5}></Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />

          <Row style={{ marginTop: 16 }}>
            <Col span={12}>
              <Text italic>In Words: {numberToWords(grandTotal)}</Text>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Text strong>Grand Total: {grandTotal}</Text>
            </Col>
          </Row>

          <Divider />

          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={8}>
              <Form layout="vertical">
                <Form.Item
                  label="Select Terms & Condition"
                  style={{ width: "100%" }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <Select
                      placeholder="Select option"
                      options={selectedTCOption}
                      value={selectedValue?.value}
                      size="large"
                      style={{ width: "70%" }}
                      onChange={(value, option) => setSelectedValue(option)}
                    />
                    <Button type="link" onClick={handlePreview}>
                      Preview
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Col>

            <Col span={8}>
              <Form layout="vertical" form={selectBank}>
                <Form.Item
                  label="Select Bank Account"
                  name="bank_ac"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    placeholder="Select option"
                    options={bankAcOption}
                    value={bankAc?.tag}
                    size="large"
                    style={{ width: "70%" }}
                    onChange={(value, option) => setBankAc(option)}
                  />
                </Form.Item>
              </Form>
            </Col>

            <Col span={8}>
              <Form layout="vertical">
                <Form.Item
                  label="Second Digital signature"
                  name="dgselect"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    allowClear
                    placeholder="Select option"
                    options={dgSignOption}
                    size="large"
                    value={dgSign?.value}
                    style={{ width: "70%" }}
                    optionRender={(option) => option.data.label}
                    fieldNames={{ label: "title", value: "value" }}
                    onChange={(value, option) => setDGsign(option)}
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>

          <Divider />

          <Row justify="end" style={{ marginTop: 16 }}>
            <Space>
              <Button size="large" type="primary" onClick={handleAddPayment}>
                Add payment Amount
              </Button>

              <Button
                size="large"
                type="primary"
                onClick={() => handlePrintInvoice(quteData?.qu_no)}
              >
                Print Quotation
              </Button>

              <Button
                disabled={!Eqslected}
                size="large"
                type="primary"
                onClick={handleSave}
              >
                Update
              </Button>

              <Popconfirm title="Sure to clear?" onConfirm={handleClear}>
                <Button disabled={!Eqslected} danger size="large">
                  Clear
                </Button>
              </Popconfirm>
            </Space>
          </Row>
        </div>
      </Card>

  <style>
    {`
      .tandc-preview ul,
      .tandc-preview ol {
        margin: 0 !important;
        padding-left: 20px !important;
        list-style: inherit !important;
      }
      .tandc-preview li {
        margin: 0 !important;
        padding: 0 !important;
        line-height: 1.4 !important;
      }
      .tandc-preview li p,
      .tandc-preview p {
        margin: 0 !important;
        padding: 0 !important;
      }
    `}
  </style>

  <Modal
    title="Preview of selected T&C"
    open={isModalOpen}
    footer={null}
    onCancel={() => setIsModalOpen(false)}
  >
    {selectedValue?.data ? (
      <div
        className="tandc-preview"
        style={{
          padding: "10px",
          border: "1px solid #f0f0f0",
          borderRadius: "8px",
          background: "#fafafa",
          minHeight: "100px",
        }}
        dangerouslySetInnerHTML={{ __html: selectedValue.data }}
      />
    ) : (
      <p>No data selected</p>
    )}
  </Modal>




      <Modal
        width={800}
        title={
          <Typography.Title level={4}>
            Add Payment for : {quotationNo}
          </Typography.Title>
        }
        open={paymentModalOpen}
        onCancel={() => setPaymentModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        {quotationNo && (
          <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />
        )}
      </Modal>
    </>
  );
};

export default EditQuotationData;
